module.exports = __webpack_public_path__ + "static/media/news1.5bdda245.png";